<template>
	<transition
    name="custom-classes-transition" :enter-active-class="'animated ' + animatedEnterClass" :leave-active-class="'animated ' + animatedLeaveClass">
		<div class="ui-modal-wrapper" v-if="open" ref="modal" style="z-index: 9998" :style="{'align-items': align}">
			<div class="ui-modal">
			<slot></slot>
			</div>
		</div>
	</transition>
</template>

<script>
import Vue from 'vue'
import overlayOpt from './overlay'
const Overlay = Vue.extend(overlayOpt)

export default {
	props: {
		open: {
      		type: Boolean,
      		default: false
    	},
    	align: {
      		type: String,
      		default: 'center'
    	},
    	animatedEnterClass: {
    		type: String,
      		default: 'bounceIn'
    	},
    	animatedLeaveClass: {
    		type: String,
      		default: 'bounceOut'
    	},
    	overlayOpacity: {
    		type: String,
    		default: '0.4'
    	}
	},
	methods: {
		showOverlay () {
			let overlay = this.overlay = new Overlay({
      			el: document.createElement('div')
    		})
    		overlay.fixed = true
		    overlay.color = '#000'
		    overlay.opacity = this.overlayOpacity
		    overlay.zIndex = '9997'
		    overlay.onClick = () => {
		    	this.closeModal()
		    }
		    document.body.appendChild(overlay.$el)
		    this.preventScrolling()
		    Vue.nextTick(() => {
		    	overlay.show = true
		    })
		},
		preventScrolling () {
		    const body = document.getElementsByTagName('body')[0]
		    const html = document.getElementsByTagName('html')[0]
		    this.bodyOverflow = body.style.overflow
		    this.htmlOverflow = html.style.overflow
		    body.style.overflow = 'hidden'
		    html.style.overflow = 'hidden'
		    this.locked = true
	  	},
	  	allowScrolling () {
		    const body = document.getElementsByTagName('body')[0]
		    const html = document.getElementsByTagName('html')[0]
		    body.style.overflow = this.bodyOverflow || ''
		    html.style.overflow = this.htmlOverflow || ''
		    this.bodyOverflow = null
		    this.htmlOverflow = null
		    this.locked = false
	  	},
	  	closeOverlay () {
	    	if (!this.overlay) return
	    	this.allowScrolling()
	    	let overlay = this.overlay
	    	overlay.show = false
	    	this.overlay = null
	    	setTimeout(() => {
                if (overlay.$el.remove) {
	      		    overlay.$el.remove();
	      		    overlay.$destroy();
                } else {
	      		    overlay.$el = null;
	      		    overlay = null;
                }
	    	}, 450)
  		},
	  	openModal () {
	  		this.$nextTick(() => {
	  			document.body.appendChild(this.$refs.modal)
	  		})
	  	},
	  	closeModal (e) {
	  		const wrapperEl = this.$refs.modal
	  		if (wrapperEl === e.target) {
	  			this.$emit('close')
	  		}
	  	},
	  	destroy () {
	  		if (!this.overlay) return
			let overlay = this.overlay
			overlay.show = false
			this.overlay = null
			document.body.removeChild(this.$refs.modal || this.$el)
		    overlay.$el.remove()
		    overlay.$destroy()
		    this.$emit('close')
	  	}
	},
	data () {
		return {
			overlay: false
		}
	},
	beforeDestroy () {
		this.destroy()
	},
	deactivated () {
		this.destroy()
	},
	watch: {
    	open (val, oldVal) {
    		if (val === oldVal) return
    		if (val) {
    			this.showOverlay()
    			this.openModal()
    		} else {
    			this.closeOverlay()
    		}
    	}
    }
}
</script>

<style>
.ui-modal-wrapper {
  	position: fixed;
  	left: 0;
  	top: 0;
  	right: 0;
  	bottom: 0;
  	display: flex;
  	justify-content: center;
  	align-items: center;
}
.ui-modal > div {
	box-shadow: 0 19px 60px rgba(0,0,0,.298039), 0 15px 20px rgba(0,0,0,.219608);
}
</style>



// WEBPACK FOOTER //
// src/components/modal/modal.vue